import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Grupo } from "../../../../../utils/types/groups/grupo.type";
import { RecordAction } from "../../../../../utils/enums/shared/enums";
import { GruposService } from "../../../../../services/groups/grupos.service";
import { AuthenticationService } from "../../../../../services/security/authentication.service";
import { TranslateService } from "@ngx-translate/core";
import { ValidationService } from "../../../../../services/validation/validation.service";

@Component({
    selector: "wtf-grupo-form",
    templateUrl: "./grupo-form.component.html",
    styleUrls: ["./grupo-form.component.scss"],
    providers: [GruposService, AuthenticationService, ValidationService],
    encapsulation: ViewEncapsulation.None,
})
export class GrupoFormComponent implements OnInit {
    grupoModel: Grupo;
    dialogTitle: string;
    grupoForm: FormGroup;
    action: RecordAction;
    callback: (grupo) => void;

    operators: any;
    // presetColors = MatColors.presets;
    recordAction = RecordAction;

    constructor(
        public dialogRef: MatDialogRef<GrupoFormComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private service: GruposService,
        private translateService: TranslateService,
        private validationService: ValidationService
    ) {
        this.grupoModel = data.grupo;
        this.action = data.action;
        this.operators = data.operators;
        this.callback = data.callback;

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.dialogTitle = this.grupoModel.name;
        } else {
            this.dialogTitle = "Nuevo Grupo";
            this.dialogTitle = this.translateService.instant(this.dialogTitle);
            this.grupoModel = new Grupo();
        }

        this.grupoForm = this.createForm();
    }

    ngOnInit() {}

    isControlValid(form: FormGroup, field: string) {
        return this.validationService.isValidField(form, field);
    }

    getErrorMessage(form: FormGroup, field: string, text: string) {
        return this.validationService.getErrorMessage(form, field, text);
    }

    createForm() {
        const form = new FormGroup({
            name: new FormControl(this.grupoModel.name, [
                Validators.required,
                Validators.maxLength(45),
                Validators.minLength(3),
                Validators.pattern(
                    "^[a-zA-ZñÑÀ-ú0-9_]+( [a-zA-ZñÑÀ-ú0-9_]+)*$"
                ),
            ]),
            isActive: new FormControl(Boolean(this.grupoModel.status)),
            operadora: new FormControl(this.grupoModel.operator_id, [
                Validators.required,
            ]),
            deleteDuplicates: new FormControl(this.grupoModel.deleteDuplicates),
        });

        form.controls["name"].valueChanges.subscribe(
            (value) => (this.grupoModel.name = value)
        );
        form.controls["isActive"].valueChanges.subscribe(
            (value) => (this.grupoModel.status = Number(value))
        );
        form.controls["operadora"].valueChanges.subscribe(
            (value) => (this.grupoModel.operator_id = value)
        );

        form.controls["deleteDuplicates"].valueChanges.subscribe(
            (value) => (this.grupoModel.deleteDuplicates = value)
        );

        return form;
    }

    performAction() {
        if (this.grupoForm.invalid) {
            return;
        }

        this.callback(this.grupoModel);
    }
}
